import React, { Component } from "react";
import WarrantNoForm from "./WarrantNoForm";
import WarrantNoList from "./WarrantNoList";
import WarrantNoAccessForm from "./WarrantNoAccessForm";
import navbar from "../../helpers/navbar"

class WarrantNoBody extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            active: <WarrantNoForm />,
            isAdmin: props.isAdmin
        };
        this.renderForm = this.renderForm.bind(this);
        this.getMyNos = this.getMyNos.bind(this);
        this.getAllNos = this.getAllNos.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isAdmin !== this.props.isAdmin) {
            this.setState({ isAdmin: this.props.isAdmin });
        }
    }
    renderForm(e) {
        navbar("selectCategory", e.target);
        this.setState({ active: <WarrantNoForm /> });
    }
    getMyNos(e) {
        navbar("selectCategory", e.target);
        this.setState({ active: <WarrantNoList filter="user"/> });
    }
    getAllNos(e) {
        navbar("selectCategory", e.target);
        this.setState({ active: <WarrantNoList filter="all"/> });
    }
    renderAccessForm(e) {
        navbar("selectCategory", e.target);
        this.setState({ active: <WarrantNoAccessForm /> });
    }
    render() {
        const adminControls = [
            <button type="button" className="selectCategory" onClick={(e) => this.getAllNos(e)} key="allNumbers">All Numbers</button>,
            <button type="button" className="selectCategory" onClick={(e) => this.renderAccessForm(e)} key="allNumberAccess">All Number Access</button>
        ];
        return (
            <div className="warrantNo__body">
                <div className="warrantNo__categories">
                    <button type="button" className="selectCategory selected" onClick={(e) => this.renderForm(e)}>New Number</button>
                    <button type="button" className="selectCategory" onClick={(e) => this.getMyNos(e)}>My Numbers</button>
                    {this.state.isAdmin ? adminControls : ""}
                </div>
                <div className="warrantNo__display">{this.state.active}</div>
            </div>
        );
    }
}

export default WarrantNoBody;